import { FormattedMessage } from 'react-intl';

import { Typography } from '@mui/material';

import { formatUserDateFromString } from '@arrived/common';
import { DividendEntry } from '@arrived/models';

import { OfferingDataList, OfferingDataListItem } from './OfferingDataList';

import { PrivacyContextAwareMoneyValue } from '../common';

interface OfferingDividendHistoryProps {
  dividends: DividendEntry[];
}

export const OfferingDividendHistory = ({ dividends }: OfferingDividendHistoryProps) => {
  if (!dividends.length) return null;
  return (
    <OfferingDataList title={<FormattedMessage id="portfolio.offeringDialog.rentalIncomeBreakdown.title" />}>
      {dividends.map((dividend, key) => {
        if (!dividend) return null;
        return (
          <OfferingDataListItem
            key={key}
            left={
              <Typography variant="h6.normal">
                <FormattedMessage
                  id="portfolio.offeringDialog.rentalIncomeBreakdown.entryTitle"
                  values={{ date: formatUserDateFromString(dividend.dividendStartDate, 'QQQ yyyy') }}
                />
              </Typography>
            }
            right={
              <Typography variant="h6.medium">
                <PrivacyContextAwareMoneyValue length={3} value={dividend.totalAmount} />
              </Typography>
            }
          />
        );
      })}
    </OfferingDataList>
  );
};
